import range from "lodash/range";
import { Skeleton } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import { Card, CardContent, CardHeader } from "../Card";
import { Column, SlotSkeleton, SlotsGrid } from "./siteSurveySchedulingStyles";
import { CardSectionDivider } from "components/atoms/Card";

type SiteSurveyAppointmentsSkeletonProps = {
  columns: number;
  testId: string;
  borderRadius?: string;
};

const LoadingWrap = styled.div`
  padding: 0;
`;

const SkeletonHeader = styled(CardHeader)`
  display: flex;
  gap: 16px;
  & > * {
    flex: 1 1 0;
  }
`;

const HeaderSkeletonCell = styled.div`
  text-align: center;
`;

const HeaderDateSkeleton = styled(Skeleton)`
  width: 100%;
  height: 1.1em;
`;

const SiteSurveyAppointmentsSkeleton: React.FC<
  SiteSurveyAppointmentsSkeletonProps
> = ({ columns, testId, borderRadius }) => (
  <LoadingWrap data-testid={testId}>
    <Card borderRadius={borderRadius}>
      <SkeletonHeader role="presentation">
        {range(columns).map((i) => (
          <HeaderSkeletonCell key={`site-survey-appt-sk-head-${i}`}>
            <HeaderDateSkeleton />
          </HeaderSkeletonCell>
        ))}
      </SkeletonHeader>
      <CardSectionDivider />
      <CardContent>
        <SlotsGrid>
          {range(columns).map((col) => (
            <Column key={`site-survey-appt-sk-col-${col}`}>
              <SlotSkeleton />
              <SlotSkeleton />
              <SlotSkeleton />
            </Column>
          ))}
        </SlotsGrid>
      </CardContent>
    </Card>
  </LoadingWrap>
);

export { SiteSurveyAppointmentsSkeleton };
export type { SiteSurveyAppointmentsSkeletonProps };
